import { render, staticRenderFns } from "./NavIndicator.vue?vue&type=template&id=2e1d2349&"
import script from "./NavIndicator.vue?vue&type=script&lang=js&"
export * from "./NavIndicator.vue?vue&type=script&lang=js&"
import style0 from "./NavIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports